
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ContractService } from 'src/app/Contracts/Services/contract.service';
import { FinanceService } from 'src/app/Finance/Services/invoice.service';
import { LoaderService } from 'src/app/Loader/loader.service';
import { SponserService } from 'src/app/MasterData/Services/sponser.service';
import { PrivilegeService } from 'src/app/Reusable/privilege.service';

import { Dateformat } from 'src/app/shared/constants/global.constants';
import { Privileges } from 'src/app/shared/constants/privileges.constants';
import { CurrencyService } from 'src/app/Reusable/currency.service';
import { FileUploadService } from 'src/app/Engagement/Services/fileupload.service';
import { TabAndStateService } from 'src/app/shared/TabAndStateService/TabAndState.Service';
import { VolumeAttachments } from 'src/app/Finance/Models/contract-volume';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-con-volume-view',
  templateUrl: './con-volume-view.component.html',
  styleUrls: ['./con-volume-view.component.css']
})
export class ConVolumeViewComponent {

  @Output() editButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelVolumeButtonClick = new EventEmitter<void>();


  @Input() contractId: any;
  @Input() volumeId: any;
  @Input() productApplicability : any;

  volumeDetail:any;
  _dateformart :any;
  selectedOption: string = 'Actions';
  editPrivilege:boolean=false;
  currentIndex: number = -1; 
  listOfVolumes:any;
  isOverrideChecked: boolean = true;
  constructor(private privilegeService: PrivilegeService,private route: ActivatedRoute,private router:Router,private loaderService: LoaderService,private datePipe: DatePipe,private financeService:FinanceService,private messageService: MessageService, private contractService: ContractService,private _fileService: FileUploadService, private masterDataService: SponserService,private currencyService: CurrencyService, private tabAndStateService: TabAndStateService ){
  }
  
  attchement:any
  currency:any;
  volumeAttachment:any;
  volumeAttachments: VolumeAttachments[]=[];
  updatedBy:any;
  remarks:any;
  searchText: any = '';
  allProducts: any;
  filteredProducts: any;
   ngOnInit() {
   this.BindData(this.volumeId);
     this._dateformart=Dateformat;
    this.BindPrivileges();
    this.listOfVolumes=this.tabAndStateService.getVolumeData();
    this.currentIndex = this.listOfVolumes.findIndex((a: { volumeDate: any; }) => a.volumeDate ==this.volumeDetail.volumeDate);
    this.allProducts = this.volumeDetail?.financeContractVolumeProducts || [];
    this.filteredProducts = [...this.allProducts];
  }

onOverrideChange() {
  if (!this.isOverrideEnabled()) {
    this.isOverrideChecked = false;
  }
}

isOverrideEnabled(): boolean {
  return this.volumeDetail?.financeContractVolumeProducts?.some(
    (row: any) => row.units != null && row.cost != null
  );
}

BindData(data:any)
{  
   if (data.productApplicability == null) {
    data.productApplicability = this.productApplicability;
  }
  this.volumeDetail =data;
  this.isOverrideChecked = this.isOverrideEnabled();
    this.volumeAttachment= new VolumeAttachments();
    this.currency= this.route.snapshot.queryParamMap.get('currency');
    if(!this.currency){
      this.currency= this.route.snapshot.paramMap.get('currency')
    }
    this.volumeDetail.productApplicability =
    this.volumeDetail.productApplicability === true ||
    this.volumeDetail.productApplicability === 'true';
    if(this.volumeDetail.id!=0)
    {
      if(this.volumeDetail?.updatedBy==null)
      this.volumeDetail.contractDetailId=this.contractId;
      
    this.updatedBy=this.privilegeService.getUserName(this.volumeDetail.updatedBy)
    if (!this.volumeDetail.financeContractVolumeAttachments) {
      this.volumeDetail.financeVolumeAttachments = [];
    }
    
    }
    else{

      this.updatedBy=null;
      this.volumeDetail.contractDetailId=this.contractId;
       if (!this.volumeDetail.financeContractVolumeAttachments) {
      this.volumeDetail.financeContractVolumeAttachments = [];
    }

    }
    this.allProducts = this.volumeDetail?.financeContractVolumeProducts || [];
    this.filteredProducts = [...this.allProducts];
}


BindPrivileges()
  {
    const hasPermission = (privilege: Privileges) => this.privilegeService.hasPermission(privilege);
    this.editPrivilege = hasPermission(Privileges.EditVolume);
  }
GetContractVolumeDetailById() {
  if(this.volumeDetail.id>0){
    this.financeService.GetContractVolumeDetailById(this.volumeDetail.id).subscribe(
      res=>{
        var volumeData=res.data;
      }
    );
  }
};


fileDetail:any;

onOptionChange(): void {//Click on Actions button navigate to edit  
  if (this.selectedOption === 'Edit') {
    var contractId= this.contractId;
    var volumeId=this.volumeDetail.id.toString();
    const data = {
      contractId:this.contractId,
      volumeId: this.volumeDetail
    };
    this.editButtonClick.emit(data);
  }    
}
BackToList()
{
  this.cancelVolumeButtonClick.emit();
}
getFormattedValue(value: number, currencyName: string): string {
  return this.currencyService.getFormattedValue(value, currencyName);
}

navigateTo(index: number): void {
  if (index >= 0 && index < this.listOfVolumes.length) {
    this.volumeDetail=this.listOfVolumes[index];
    this.BindData(this.volumeDetail);
    this.currentIndex=index;
  }
}
nextRecord(): void {
  this.navigateTo(this.currentIndex + 1);
}
previousRecord(): void {
  this.navigateTo(this.currentIndex - 1);
}
getCurrentPositionText(): string {
  return `${this.currentIndex + 1} of ${this.listOfVolumes.length}`;
}

downloadAttachment(data:any)
{
  var attachment = this.volumeDetail?.financeContractVolumeAttachments.find((attachment: { fileName: any; }) => attachment.fileName === data.fileName);

  if (attachment !== null) {
    this.downloadFile(attachment?.fileName, attachment?.filePath);
  }

}

async downloadFile(fileName:any,filePath:any){
this.loaderService.showLoader();
var fileDetail = {
  "fileName":fileName,
  "filePath":filePath
};
this._fileService.DownloadFile(fileDetail).subscribe(
  async (res:any)=>{
      var blobData = this._fileService.dataURItoBlob(res);
      if(blobData.size>0){
         var response = await this._fileService.downloadBase64File(blobData,fileDetail.fileName);
         this.loaderService.hideLoader();
      }
      else{
        this.loaderService.hideLoader();
        
      }
  });
}

getTotalUnits(): number {
  if (!this.volumeDetail?.financeContractVolumeProducts) {
    return 0;
  }

  return this.volumeDetail.financeContractVolumeProducts
    .reduce((total: number, item: any) => total + (item.units || 0), 0);
}

getTotalCost(): number {
  if (!this.volumeDetail?.financeContractVolumeProducts) {
    return 0;
  }

  return this.volumeDetail.financeContractVolumeProducts
    .reduce((total: number, item: any) => total + (item.cost || 0), 0);
}

filterProducts() {
  if (!this.searchText || this.searchText.trim() === '') {
    this.filteredProducts = [...this.allProducts];
    return;
  }

  const search = this.searchText.toLowerCase();

  this.filteredProducts = this.allProducts.filter((product: { productName: string; }) =>
    product.productName?.toLowerCase().includes(search)
  );
}
clearFilter() {
  this.searchText = '';
  this.filterProducts()
}
}
